import { render, staticRenderFns } from "./ManualPaymentList.vue?vue&type=template&id=4b2e5d83&"
import script from "./ManualPaymentList.vue?vue&type=script&lang=js&"
export * from "./ManualPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports